import React, { useEffect, useState } from "react";
import axios from "../../../lib/axios";
import ViewStudent from "./AdminViewTeacher";
import "./AdTeacher.scss";

import { Delete } from "@mui/icons-material";
import TechAddLesson from "./AdminAddTeacher";
import TechUpdateLesson from "./AdminUpdateTeacher";
import AdNavbar from "../AdNavbar/AdNavbar";
import Pagination from "@mui/material/Pagination"; // Import Pagination
import Stack from "@mui/material/Stack"; // Impo

export default function AdTeacher() {
  const useAuth = window.localStorage;
  const Token = useAuth.getItem("accessToken");
  const [teachers, setTeachers] = useState();
  const [change, setChange] = useState(false);
  const [page, setPage] = useState(1); // Current page state
  const [totalPages, setTotalPages] = useState(1); // Total pages state
  const [limit] = useState(10); // Number of items per page

  const config = {
    headers: {
      Authorization: Token,
    },
  };

  useEffect(() => {
    axios
      .get(`teachers?page=${page}&limit=${limit}`, config)
      .then((response) => {
        console.log(response.data);
        setTeachers(response.data.teachers);
        setTotalPages(response.data.count < limit ? 1 : Math.ceil(response.data.count / limit)); // Assuming your API returns the total number of pages
      })
      .catch((err) => {
        console.log(err);
      });
  }, [page]);

  const deleteLesson = (id) => {
    if (window.confirm("Ustozni o'chirmoqchimisiz?")) {
      axios
        .delete(`teacher/${id}`, config)
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const toggleAction = (e) => {
    const actionBody = e.target.nextSibling;
    console.log(actionBody, "actionBody");
    if (actionBody.style.display === "block") {
      actionBody.style.display = "none";
    } else {
      actionBody.style.display = "block";
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value); // Update the page state when user changes the page
  };

  return (
    <>
      <AdNavbar />
      <main className="mainPage">
        {(
          <section className="mygroup-section tech-lesson-section ad-teacher">
            <div className="container">
              <div className="mygroup">
                <table className="mygroup__table desktop">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Ustozlar</th>
                      <th>Login</th>
                      <th className="add-wrapper">
                        <TechAddLesson />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {teachers &&
                      teachers.map((item, index) => (
                        <tr key={index} id={item.id}>
                          <td>{index + 1}</td>
                          <td id="lessonName">
                            <p onClick={() => setChange(!change)}>
                              {item.first_name + " " + item.last_name}
                            </p>
                          </td>
                          <td>
                            <p>{item.login}</p>
                          </td>
                          <td className="add-wrapper">
                            <ViewStudent data={item} />
                            <TechUpdateLesson data={item} />
                            <button
                              className="btn-delete"
                              onClick={() => deleteLesson(item.id)}
                              style={{ color: "crimson" }}
                            >
                              <Delete />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <div className="mygroup__table mobile">
                  <div className="mygroup__table-head">
                    <div className="">#</div>
                    <div className="">Ustozlar</div>
                    <TechAddLesson/>
                  </div>
                  <div className="mygroup__table-body">
                    {teachers &&
                      teachers.map((item, index) => (
                        <div key={index} className="mygroup__table-body--item">
                          <div className=""><p>{index + 1}</p></div>
                          <div className="group-name">
                          <p onClick={() => setChange(!change)}>
                              {item.first_name + " " + item.last_name}
                            </p>                            </div>
                            <div>
                              <button className="btn-action"
                                onClick={ toggleAction}>
                                  •••
                              </button>
                              <div className="ad-teacher-action-body">
                                <ViewStudent data={item} />
                                <TechUpdateLesson data={item} />
                                <button
                                  className="btn-delete"
                                  onClick={() => deleteLesson(item.id)}
                                  style={{ color: "crimson" }}
                                >
                                  <Delete />
                                </button>
                              </div>
                            </div>
                        </div>
                      ))}
                  </div>
                </div>
                <Stack spacing={2} alignItems="center" marginTop="20px">
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    color="secondary"
                    variant="outlined"
                    shape="rounded"
                  />
                </Stack>
              </div>
            </div>
          </section>
        )}
      </main>
    </>
  );
}
